module.exports = __webpack_public_path__ + "img/401.b60976b2.jpg";